import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CheckBox extends Component {
  getChildContext() {
    const { selectedValues, onChange } = this.props;
    return {
      checkBox: {
        selectedValues,
        onChange,
      },
    };
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

CheckBox.propTypes = {
  children: PropTypes.node.isRequired,
  selectedValues: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
  ),
  onChange: PropTypes.func,
};

CheckBox.defaultProps = {
  selectedValues: [],
  onChange: () => {},
};

CheckBox.childContextTypes = {
  checkBox: PropTypes.object,
};

export default CheckBox;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/subComponents/CheckBox/CheckBox.jsx